const networkData = {
    "linesOfNetwork": [
        {
            "id": "aabb50d2-2448-4ba4-8d3d-039d467064bd",
            "name": "Hora-Malesov_all",
            "networkId": "2d26167a-9bdd-4965-81e6-f5cc33c310e4",
            "railwayEdgeIds": "22ecc1eb-189e-4203-88f4-18642bda2f76"
        }
    ],
    "edgesOfNetwork": [
        {
            "railwayEdgeId": "22ecc1eb-189e-4203-88f4-18642bda2f76",
            "railwayEdgeName": "E1",
            "networkId": "2d26167a-9bdd-4965-81e6-f5cc33c310e4",
            "length": 1355.2161181149522,
            "lineString": {
                "type": "LineString",
                "coordinates": [
                    [
                        15.274960398674013,
                        49.9475851537217
                    ],
                    [
                        15.2748034,
                        49.9474414
                    ],
                    [
                        15.2746832,
                        49.9473252
                    ],
                    [
                        15.27464658021927,
                        49.94728828602615
                    ],
                    [
                        15.274316668510439,
                        49.947036292244206
                    ],
                    [
                        15.274013578891756,
                        49.94687577496971
                    ],
                    [
                        15.273734629154207,
                        49.94676013316088
                    ],
                    [
                        15.273487865924837,
                        49.946687641139164
                    ],
                    [
                        15.273157954216005,
                        49.94660997099482
                    ],
                    [
                        15.272795855998995,
                        49.94655991683545
                    ],
                    [
                        15.272455215454103,
                        49.946540930761394
                    ],
                    [
                        15.272087752819063,
                        49.94656164284179
                    ],
                    [
                        15.272018015384676,
                        49.94656682086051
                    ],
                    [
                        15.271891951560974,
                        49.946571998878696
                    ],
                    [
                        15.271288454532625,
                        49.94665139508739
                    ],
                    [
                        15.2703714,
                        49.9467649
                    ],
                    [
                        15.270065367221834,
                        49.94680673511726
                    ],
                    [
                        15.269738137722017,
                        49.94682917308017
                    ],
                    [
                        15.2696303,
                        49.9468261
                    ],
                    [
                        15.2692517,
                        49.9468139
                    ],
                    [
                        15.269201695919039,
                        49.94680328312204
                    ],
                    [
                        15.2687108,
                        49.9467484
                    ],
                    [
                        15.2685898,
                        49.9467318
                    ],
                    [
                        15.2685519,
                        49.9467291
                    ],
                    [
                        15.268372893333437,
                        49.946699723150374
                    ],
                    [
                        15.268217325210573,
                        49.94668073713141
                    ],
                    [
                        15.268128812313082,
                        49.94667038111791
                    ],
                    [
                        15.267943739891054,
                        49.94663586105686
                    ],
                    [
                        15.267806947231295,
                        49.946620327021314
                    ],
                    [
                        15.2677122,
                        49.9465953
                    ],
                    [
                        15.267463624477388,
                        49.946540930761394
                    ],
                    [
                        15.267077386379244,
                        49.94640975404521
                    ],
                    [
                        15.266825258731844,
                        49.94627339892208
                    ],
                    [
                        15.266661643981935,
                        49.94615948168783
                    ],
                    [
                        15.266473889350893,
                        49.94598170122336
                    ],
                    [
                        15.26627540588379,
                        49.945752139070485
                    ],
                    [
                        15.2662172,
                        49.9456605
                    ],
                    [
                        15.266015231609346,
                        49.945298189637626
                    ],
                    [
                        15.265717506408693,
                        49.9447458499577
                    ],
                    [
                        15.265435874462128,
                        49.94419868221777
                    ],
                    [
                        15.265221297740938,
                        49.94376370532153
                    ],
                    [
                        15.26503622531891,
                        49.94335634244451
                    ],
                    [
                        15.265001356601717,
                        49.94327694080459
                    ],
                    [
                        15.264950394630434,
                        49.94321307417319
                    ],
                    [
                        15.264875292778017,
                        49.9431095064828
                    ],
                    [
                        15.264741182327272,
                        49.94296796361255
                    ],
                    [
                        15.264631211757662,
                        49.94286266925635
                    ],
                    [
                        15.264593660831453,
                        49.942829872606616
                    ],
                    [
                        15.264330804347994,
                        49.942583033947365
                    ],
                    [
                        15.264287889003755,
                        49.942536427904706
                    ],
                    [
                        15.2642164,
                        49.9424728
                    ],
                    [
                        15.264100134372713,
                        49.94228786158245
                    ],
                    [
                        15.264038443565369,
                        49.94213078081472
                    ],
                    [
                        15.263998210430147,
                        49.94192881907503
                    ],
                    [
                        15.264003574848177,
                        49.94165263070996
                    ],
                    [
                        15.264008939266207,
                        49.94162155941982
                    ],
                    [
                        15.264081358909607,
                        49.94115203526263
                    ],
                    [
                        15.264183282852175,
                        49.94066179192116
                    ],
                    [
                        15.2643035,
                        49.9402934
                    ]
                ]
            }
        }
    ],
    "network": [
        {
            "networkId": "2d26167a-9bdd-4965-81e6-f5cc33c310e4",
            "organisationsId": "9b2cbf98-f31d-4091-b600-f7014bf5c7a3",
            "networkName": "Hora-Malesov",
            "networkIcon": null,
            "location": "",
            "mainCity": "",
            "country": "",
            "centerGeoPoint": {
                "type": "Point",
                "coordinates": [
                    15.26815933,
                    49.94518204
                ]
            },
            "active": 1,
            "defaultStartEdge": "22ecc1eb-189e-4203-88f4-18642bda2f76",
            "lineMeterOnDefaultStartEdge": 0,
            "defaultEndEdge": "22ecc1eb-189e-4203-88f4-18642bda2f76",
            "lineMeterOnDefaultEndEdge": 0,
            "timeStamp": "0001-01-01T00:00:00",
            "editorStepProcessed": 0,
            "edgeDataExist": false,
            "trackCount": 0
        }
    ]
}

export default networkData